import styled, { css } from 'styled-components';

export const CheckboxWindow = styled.span`
  position: relative;

  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-right: 10px;

  border: 1px solid #e5e5e5;
  border-radius: ${({radio}) => radio ? '10px' : '2px'};

  transition: background-color 0.3s, border-color 0.3s;

  &::before {
    content: "";

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: none;
    width: 12px;
    height: 9px;

    background: transparent no-repeat center / contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='9' fill='none'%3E%3Cpath stroke='%23505050' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 5l3 3 7-7'/%3E%3C/svg%3E");
  }

  ${({ blue }) => blue && css`
    &::before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='9' fill='none'%3E%3Cpath stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 5l3 3 7-7'/%3E%3C/svg%3E");
    }
  `}

  ${({ invalid, theme }) => invalid && css`
    border-color: ${theme.red};
  `}
`;

export const CheckboxLabel = styled.label`
  flex-direction: ${({ checkboxToRight }) => checkboxToRight ? 'row-reverse' : 'row'};
  display: flex;
  align-items: flex-start;

  font-weight: ${({ normal }) => normal ? 400 : 600};
  font-size: 16px;
  line-height: 19px;

  cursor: pointer;

  &:hover ${CheckboxWindow} {
    border-color: ${({ theme }) => theme.blue}
  }

  span {
   display: flex;
   flex-direction: column;
  }

  p {
    margin: 0;
    margin-top: 5px;
    padding: 0;

    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const CheckboxContainer = styled.div`
  color: ${({ theme }) => theme.black};
  user-select: none;

  input:checked ~ ${CheckboxLabel} ${CheckboxWindow} {
    border-color: ${({ theme }) => theme.yellow};
    background-color: ${({ theme }) => theme.yellow};

    &::before {
      display: block;
    }
  }

  ${({ blue, theme }) => blue && css`
    input:checked ~ ${CheckboxLabel} ${CheckboxWindow} {
      border-color: ${theme.blue};
      background-color: ${theme.blue};
    }
  `}
`;
